import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * Reusable SEO component for adding meta tags and schema markup to pages
 */
const SEOHead = ({ 
  title, 
  description, 
  path = '/',
  type = 'WebPage',
  schemaData = null,
  noIndex = false 
}) => {
  // Get base URL from environment variable or use production URL as fallback
  const baseUrl = process.env.REACT_APP_SITE_URL || 'https://urgaa.in';
  const fullUrl = `${baseUrl}${path}`;
  const ogImageUrl = `${baseUrl}/images/og-default.jpg`;
  
  // Default schema for web pages
  const defaultSchema = {
    "@context": "https://schema.org",
    "@type": type,
    "name": title,
    "description": description,
    "url": fullUrl,
    "isPartOf": {
      "@type": "WebSite",
      "name": "URGAA",
      "url": baseUrl
    },
    "provider": {
      "@type": "Organization",
      "name": "Go4Garage Private Limited",
      "url": baseUrl,
      "logo": {
        "@type": "ImageObject",
        "url": `${baseUrl}/assets/go4garage-lockup.svg`
      }
    }
  };
  
  const schema = schemaData || defaultSchema;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title} | URGAA</title>
      <meta name="title" content={`${title} | URGAA`} />
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={`${title} | URGAA`} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImageUrl} />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:site_name" content="URGAA" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={`${title} | URGAA`} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImageUrl} />
      <meta name="twitter:site" content="@Go4Garage" />
      
      {/* Additional Meta */}
      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      <meta name="language" content="English" />
      <meta name="author" content="Go4Garage Private Limited" />
      <meta name="geo.region" content="IN" />
      <link rel="canonical" href={fullUrl} />
      
      {/* Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default SEOHead;
